export const ssoConfig = {
  appId: 22,
  sso: {
    tokenExpiresInMin: 2,
    timeBeforeCallingRefreshInSecs: 15
  },
};
